import styled from 'styled-components'
import theme from '../../styles/theme'
import {
  AccordionWrapper,
  AccordionHeader,
  AccordionTitle,
} from '../Accordion/style'
import { CardBody } from '../InformationCard/styles'
import { CardText } from '../PageFooter/Footer.styled'
export const CardWrapper = styled(AccordionWrapper)`
  display: flex;
  border: 5px solid ${theme.color.bgAlert};
  border-radius: 15px;
`
export const AlertStatusCard = styled.img`
  background-color: ${theme.color.bgAlert};
  padding: 0 10px;
`
export const AlertCardContainer = styled.div`
  width: 100%;
`
export const AlertCardHeader = styled(AccordionHeader)`
  box-shadow: none;
  padding: 20px 1rem;
`

export const AlertCardTitle = styled(AccordionTitle)``

export const CardContentWrapper = styled(CardBody)`
  padding: 0 1rem 10px 1rem;
  box-shadow: none;
  border-radius: 15px;
`
export const AlertCardText = styled(CardText)``
